export default{
    categorias: [],
    categoriaSelec: null,
}